// ABOUTME: Validation schema for a workspace, shared by the add-workspace modal and
// ABOUTME: the workspace details sidepanel. A label printer is only required when auto printing.

import * as yup from "yup";
import { yupRequired, yupNumberRequired } from "./validation";

// autoPrint arrives as a boolean from the API and as a string from the toggle buttons
const isAutoPrintOn = (autoPrint) => autoPrint === true || autoPrint === "true";

export const buildWorkspaceSchema = (t) =>
    yup.object().shape({
        name: yupRequired('name', t),
        printer_label: yup.mixed().when('autoPrint', {
            is: isAutoPrintOn,
            then: () => yupNumberRequired('printer_label', t),
            otherwise: (schema) => schema.notRequired(),
        }),
        warehouseId: yupNumberRequired('warehouseId', t),
    });
